<script setup>
const wcagStore = useWcagStore();

const emit = defineEmits(["next-block", "previous-block", "final-block"]);
// Selected option
const selectedOption = ref(null);
const error = ref("");

// Handle next button click
const handleNext = () => {
  if (!selectedOption.value) {
    error.value = "Maak een keuze om verder te gaan";
    return;
  }
  wcagStore.setHasAccessibilityStatement(
    selectedOption.value === "yes" ? true : false
  );
  error.value = "";
  emit("next-block", selectedOption.value);
};

// Handle previous button click
const handlePrevious = () => {
  emit("previous-block");
};
</script>

<template>
  <div class="relative flex flex-col items-center justify-center">
    <video
      class="bg-black w-[175px] h-[175px] object-cover object-center rounded-full mb-lg"
      autoplay
      loop
      muted
      playsinline
    >
      <source
        src="https://res.cloudinary.com/hello-sunshine/video/upload/v1746189135/6296923_Psychologist_Therapy_Patient_Woman_By_Frame_Stock_Footage_Artlist_HD.mp4"
        type="video/mp4"
      />
    </video>

    <div class="flex flex-col items-center justify-center">
      <div class="italic mb-sm"><b>Vraag 2</b> van de 4</div>
      <div class="font-bold text-center text-2xl pb-md">
        Is er een geldige toegankelijkheidsverklaring?
      </div>

      <!-- Radio buttons -->
      <div class="my-lg w-full bg-black text-white">
        <label
          class="radio block py-xs px-xs border-x border-t border-gray-darker cursor-pointer"
        >
          <input
            type="radio"
            v-model="selectedOption"
            value="yes"
            name="research"
            class="mr-2"
          />
          Ja
        </label>

        <label
          class="radio block py-xs px-xs border-x border-t border-gray-darker cursor-pointer"
        >
          <input
            type="radio"
            v-model="selectedOption"
            value="no"
            name="research"
            class="mr-2"
          />
          Nee
        </label>

        <label
          class="radio block py-xs px-xs border border-gray-darker cursor-pointer"
        >
          <input
            type="radio"
            v-model="selectedOption"
            value="unknown"
            name="research"
            class="mr-2"
          />
          Niet bekend
        </label>
      </div>
      <div v-if="error">
        <span class="text-red text-sm mt-2 mb-2">{{ error }}</span>
      </div>
      <!-- Navigation Buttons -->
      <div class="flex flex-row w-full">
        <div class="w-1/2 mr-xl">
          <button @click="handlePrevious" class="btn btn--border w-full">
            Vorige
          </button>
        </div>
        <div class="w-1/2">
          <button @click="handleNext" class="btn w-full">Volgende</button>
        </div>
      </div>
    </div>
  </div>
</template>
